import { CardInputWithType, ECardType, LinkInput } from '__generated__/globalTypes';
import { CreateGuideStoryVariables } from 'graphql/mutation/__generated__/CreateGuideStory';
import { GuideQuery_guide_stories } from 'graphql/query/__generated__/GuideQuery';

const importKey = 'Timestamp';

function parser(guideId: string, row: Record<string, string>): CreateGuideStoryVariables {
    const mutationPayload: CreateGuideStoryVariables = {
        guideId,
        story: {
            importKey: row[importKey],
            header: {
                title: row['Bedrijfnaam | Company Name'],
                text: row[
                    'Een korte beschrijving van uw bedrijf. Dit zal gebruikt worden op onze website voor studenten (max. 100 woorden) | Short description of your company that will be displayed on our website for students to read (max. 100 words)'
                ]
                // imageUrl: row['img'],
                // imageStyleId: 'stretch'
            }
        },
        cards: []
    };

    // const hasContactCard = row['Telefoonnummer | Phone number'] || row['E-mail'];
    // const contactCard: CardInputWithType = {
    //     type: ECardType.TEXT,
    //     info: {
    //         title: 'Contact',
    //         description: (() => {
    //             let text = '';

    //             if (row['Telefoonnummer | Phone number']) {
    //                 text += `**Telefoonnummer:** ${row['Telefoonnummer | Phone number'].trim()}\n`;
    //             }

    //             if (row['E-mail']) {
    //                 text += `**Email:** ${row['E-mail'].trim()}\n`;
    //             }

    //             return text;
    //         })()
    //     }
    // };

    const hasLinkCard = row['Link naar uw website | Link to your company website'];
    const linkCard: CardInputWithType = {
        type: ECardType.LINK,
        links: (() => {
            const links: LinkInput[] = [];
            if (row['Link naar uw website | Link to your company website']) {
                links.push({
                    title: 'Website',
                    url: row['Link naar uw website | Link to your company website']
                });
            }
            return links;
        })()
    };

    // if (hasContactCard) {
    //     mutationPayload.cards.push(contactCard);
    // }
    if (hasLinkCard) {
        mutationPayload.cards.push(linkCard);
    }

    return mutationPayload;
}

function duplicateChecker(story: GuideQuery_guide_stories, row: Record<string, string>): boolean {
    return story.importKey?.toLowerCase() === row[importKey]?.toLowerCase();
}

export const utrechtImportMethods = { duplicateChecker, parser };
